import React from "react";

/** Category: a folder. */
const CategoryIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 7.5V18a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 18V9.5A1.5 1.5 0 0 0 19.5 8h-7.6l-2-2.5H4.5A1.5 1.5 0 0 0 3 7Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
      <path d="M3 11h18" stroke="currentColor" strokeWidth="1.7" />
    </svg>
  );
};

export default CategoryIcon;
